const quantityInput = (element, options, observer) => {
    const spinner = element.querySelector('.quantity')
    const isFastBuyForm = element.parentElement.classList.contains('fast-buy-cell')
    const defaultOptions = {
        min: 0.1,
        max: 99999999,
        value: 1,
        allowDecimalQuantity: false,
        step: 1,
    }

    options = Object.assign({}, defaultOptions, options)
    const allowDecimal = options.allowDecimalQuantity === '1'

    const obj = {
        observer: observer,
        input: spinner.querySelector('.quantity-input') || spinner.querySelector('input'),
        isDisabled: !isFastBuyForm,
        allowDecimalQuantity: allowDecimal,
        step: allowDecimal ? 0.1 : 1,

        init() {
            if (!this.input) return this
            this.setup()
            this.events()
            this.initObservers()
            return this
        },

        setup() {
            this.input.type = 'text' // 🔹 UPDATED: allows comma input
            const initialValue = options.value ?? this.min
            this.input.value = allowDecimal
                ? this.format(this.parse(initialValue), '.', true)
                : initialValue
            this.max = options.max
            this.min = allowDecimal ? 0.1 : 1

            const qUp = document.createElement('div')
            const qDown = document.createElement('div')

            qUp.className = 'quantity-button quantity-button--up'
            qDown.className = 'quantity-button quantity-button--down'

            qUp.innerHTML = '<i class="icon icon-plus"></i>'
            qDown.innerHTML = '<i class="icon icon-minus"></i>'

            spinner.insertBefore(qDown, this.input)
            spinner.appendChild(qUp)

            this.btnUp = qUp
            this.btnDown = qDown
        },

        /* ================= HELPERS ================= */

        normalize(val) {
            return String(val).replace(',', '.')
        },

        parse(val) {
            const num = Number(this.normalize(val))
            if (isNaN(num)) return NaN

            return allowDecimal
                ? Math.round(num * 10) / 10
                : Math.floor(num)
        },

        getSeparator(val) {
            return String(val).includes(',') ? ',' : '.'
        },

        format(val, separator, fixed = false) {
            let str = fixed ? val.toFixed(1) : String(val)
            return separator === ',' ? str.replace('.', ',') : str
        },

        publishQuantity() {
            this.observer.publish('cartQuantity', {
                quantity: this.input.value,
                isFastBuyForm: isFastBuyForm,
                allowDecimalQuantity: allowDecimal ? '1' : null,
            })
        },

        /* ================= EVENTS ================= */

        events() {
            /* + BUTTON */
            this.btnUp.addEventListener('click', (e) => {
                e.stopPropagation()
                if (this.isDisabled) return

                const raw = this.input.value
                const separator = this.getSeparator(raw)

                let val = this.parse(raw)
                if (isNaN(val)) val = this.min

                const step = options.getStep ? options.getStep() : this.step
                val = Math.min(val + step, this.max)

                this.input.value = allowDecimal
                    ? this.format(val, separator, true)
                    : val

                this.publishQuantity()
            })

            /* − BUTTON */
            this.btnDown.addEventListener('click', (e) => {
                e.stopPropagation()
                if (this.isDisabled) return

                const raw = this.input.value
                const separator = this.getSeparator(raw)

                let val = this.parse(raw)
                if (isNaN(val)) val = this.min

                const step = options.getStep ? options.getStep() : this.step
                const minVal = options.getMin ? options.getMin() : this.min
                val = Math.max(val - step, minVal)

                this.input.value = allowDecimal
                    ? this.format(val, separator, true)
                    : val

                this.publishQuantity()
            })

            /* LIVE INPUT FILTER */
            this.input.addEventListener('input', () => {
                let val = this.input.value

                if (allowDecimal) {
                    val = val.replace(/[^0-9.,]/g, '')

                    const parts = val.split(/[.,]/)
                    if (parts.length > 2) {
                        val = parts[0] + val.match(/[.,]/)[0] + parts.slice(1).join('')
                    }
                } else {
                    val = val.replace(/\D/g, '')
                }
                this.input.value = val
            })

            /* CHANGE (VALIDATE & FORMAT) */
            this.input.addEventListener('blur', () => {
                const raw = this.input.value
                const separator = this.getSeparator(raw)

                let val = this.parse(raw)
                if (isNaN(val)) val = this.min

                if (val < this.min) val = this.min
                if (val > this.max) val = this.max

                this.input.value = allowDecimal
                    ? this.format(val, separator, false)
                    : val
                this.publishQuantity()
            })
        },
        initObservers() {
            this.observer.subscribe({
                event: 'disableQuantityField',
                action: (state) => {
                    if (!isFastBuyForm) {
                        this.isDisabled = state
                        this.input.disabled = state
                    }
                },
            })
        },
    }
    return obj.init()
}

export default quantityInput
